import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MsalInterceptor } from '@azure/msal-angular';
import { AboutComponent } from './components/about/about.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { AuthenticationService } from './services/authentication.service';
import { MessagingService } from './services/messaging.service';
import { SharedService } from './services/shared.service';
import { AngularMatModule } from './angular-mat-lib/angular-mat-lib.module';
import { FooterComponent } from './components/footer/footer.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';

import { SideNavComponent } from './components/side-nav/side-nav.component';
import { DownloadPopupComponent } from './components/download-popup/download-popup.component';
import { VideoPopupComponent } from './components/video-popup/video-popup.component';
import { AlertPopupComponent } from './components/alert-popup/alert-popup.component';
import { InfoPopupComponent } from './components/info-popup/info-popup.component';
import { TaskListPopupComponent } from './components/task-list-popup/task-list-popup.component';
import { OverlayMessageComponent } from './components/overlay-message/overlay-message.component';



// import { NgxSpinnerModule } from "ngx-spinner";
//If you want your service to share data amongst all modules, place them here
const SingletonServices: Provider[] = [
  SharedService,
  AuthenticationService,
  MessagingService,
  HttpClientModule,
];

@NgModule({
  declarations: [
    ToolbarComponent,
    AboutComponent,
    FooterComponent,
    ProgressBarComponent,
    SideNavComponent,
    DownloadPopupComponent,
    VideoPopupComponent,
    AlertPopupComponent,
    InfoPopupComponent,
    TaskListPopupComponent,
    OverlayMessageComponent,
 



    // NgxSpinnerModule
  ],
  imports: [FormsModule, CommonModule, AngularMatModule, RouterModule],
  exports: [
    AngularMatModule,
    ToolbarComponent,
    FooterComponent,
    ProgressBarComponent,
    SideNavComponent,
    AlertPopupComponent,
    OverlayMessageComponent,

    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: SingletonServices,
    };
  }
}
